import React from 'react';

import useLediumPage from '@client/hooks/useLediumPage';
import { usePageStore } from '@client/store/pageStore/context/pageContext';

import GroupsView from './GroupsView';

const Groups = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    const { mainMenu, onSave } = useLediumPage({
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            parent: formData.parent
        })
    });

    if (!formData.loaded) {
        return null;
    }

    return <GroupsView onClose={mainMenu} onSave={onSave} />;
};

export default Groups;
